import { useMemo } from "react";
import chartDefinitions from "../constants/chartDefinitions";

export default function useChartData({ daily, hourly, translatedWsData }) {
  return useMemo(() => {
    const dataMap = {
      t2m_dmax: daily.map((d) => d.t2m_dmax),
      t2m_dmin: daily.map((d) => d.t2m_dmin),
      tp_dsum: daily.map((d) => d.tp_dsum),
      rh2m_dm: daily.map((d) => d.rh2m_dm),
      rh2m_dmin: daily.map((d) => d.rh2m_dmin),
      rh2m_dmax: daily.map((d) => d.rh2m_dmax),
      t2m_dm: daily.map((d) => d.t2m_dm),
      ssrd_dsum: daily.map((d) => d.ssrd_dsum),
      sshn_dsum: daily.map((d) => d.sshn_dsum),
      e_dsum: daily.map((d) => d.e_dsum),
      sde_dsum: daily.map((d) => d.sde_dsum),
      cu_dacc: daily.map((d) => d.cu_dacc),
      ff_10m_dmax: daily.map((d) => d.ff_10m_dmax),
      dd_10m_dmax: daily.map((d) => d.dd_10m_dmax),
      ff_10m_dm: daily.map((d) => d.ff_10m_dm),
      d2m_dm: daily.map((d) => d.d2m_dm),
      skt_dmin: daily.map((d) => d.skt_dmin),
      ss_dsum: daily.map((d) => d.ss_dsum),
      mx2t: daily.map((d) => d.mx2t),
      mn2t: daily.map((d) => d.mn2t),

      // Hourly
      t2m: hourly.map((d) => d.t2m),
      tp: hourly.map((d) => d.tp),
      fg10: hourly.map((d) => d.fg10),
      skt: hourly.map((d) => d.skt),
      ws: translatedWsData,
    };

    return chartDefinitions.map((def) => ({
      ...def,
      data: dataMap[def.key] ?? [],
    }));
  }, [daily, hourly, translatedWsData]);
}
